export default __webpack_public_path__ + "023414178901b2604eded083140f9f7a.svg";